import React from 'react';

const Footer = () => {
  return (
    <footer style={{background: 'var(--dark)', color: 'white', padding: '40px 5%', textAlign: 'center'}}>
      <p>RANGKA RAYA SDN BHD (<code>199401015300</code>/300980-H)</p>
      <p>No 3 & 5, Jalan Kenari 4, Puchong Jaya, 47100 Puchong, Selangor</p>
      <br />
      <p>© 2025 RANGKA RAYA SDN BHD. All Rights Reserved.</p>
    </footer>
  );
};

export default Footer;
